import { render } from "./UpDownGradeButtons.vue?vue&type=template&id=2499f251"
import script from "./UpDownGradeButtons.vue?vue&type=script&lang=js"
export * from "./UpDownGradeButtons.vue?vue&type=script&lang=js"

import "./UpDownGradeButtons.vue?vue&type=style&index=0&id=2499f251&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__